document.addEventListener('DOMContentLoaded', function () {
  const containerElement = document.querySelector('.custom-image-banner');
  const elements = document.querySelectorAll('.custom-image-banner .animate__animated');

  // Check if the viewport width is below 768px (mobile devices)
  if (window.matchMedia('(max-width: 768px)').matches) {
    if (containerElement) {
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              elements.forEach((el) => {
                if (!el.classList.contains('animate__fadeInUpBig')) {
                  el.classList.add('animate__fadeInUpBig');
                  el.classList.remove('hidden-before-animate');
                  el.style.visibility = 'visible';
                  el.style.opacity = '1';
                }
              });
              observer.unobserve(entry.target); // Unobserve to avoid multiple triggers
            }
          });
        },
        {
          threshold: 0.1,
        }
      );
      observer.observe(containerElement);
    } else {
      console.log('containerElement not found');
    }
  } else {
    elements.forEach((el) => {
      el.classList.remove('hidden-before-animate');
    });
  }
});
